import React from 'react'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { Single } from '@core/Areas/Kambi/Components/BetHistory/BetInfo/Components/Single/Single'
import { SameGameMulti } from './Components/SameGameMulti/SameGameMulti'
import { Multi } from './Components/Multi/Multi'
import { getKambiCouponBetType } from '../helpers/getKambiCouponBetType'

export const BetInfo: React.FC<{
  ticket: BetLoopKambiShareCoupon
}> = ({ ticket }) => {
  switch (getKambiCouponBetType(ticket)) {
    case 'same-game-multi':
      return <SameGameMulti ticket={ticket} />
    case 'multi':
      return <Multi ticket={ticket} />
    default:
      return <Single ticket={ticket} />
  }
}
